// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!./~/vue-style-loader!./~/css-loader?{"minimize":true,"sourceMap":true,"url":true}!./~/vue-loader/lib/style-compiler?{"id":"data-v-00ef570c","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/developerInfo/components/SubmissionCategoryDialog.vue
// module id = 2163
// module chunks = 68